import { LoginForm } from "@/components/login-form";
import { LanguageSelect } from "@/components/language-select";

export default function LoginPage() {
  return (
    <div className="relative flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      {/* the header with the language switch is not shown before signing in */}
      <div className="absolute right-3 top-2 sm:right-4">
        <LanguageSelect />
      </div>
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
}
